import React from "react";
import styles from "./text-input-field.module.scss";

interface TextInputFieldProps {
	value?: string;
	onChange: (value: string) => void;
	placeholder?: string;
	multiline?: boolean;
	type?: "text" | "number";
	maxLength?: number;
	min?: number;
	max?: number;
	disabled?: boolean;
	hasError?: boolean;
}

const TextInputField: React.FC<TextInputFieldProps> = ({
	value = "",
	onChange,
	placeholder,
	multiline = false,
	type = "text",
	maxLength,
	min,
	max,
	disabled = false,
	hasError = false,
}) => {
	const className = `${styles.field} ${hasError ? styles.error : ""}`;

	if (multiline) {
		return (
			<textarea
				className={`${className} ${styles.textarea}`}
				value={value}
				placeholder={placeholder}
				maxLength={maxLength}
				disabled={disabled}
				rows={3}
				onChange={e => onChange(e.target.value)}
			/>
		);
	}

	return (
		<input
			className={className}
			type={type}
			value={value}
			placeholder={placeholder}
			maxLength={maxLength}
			min={min}
			max={max}
			disabled={disabled}
			onChange={e => onChange(e.target.value)}
		/>
	);
};

export default TextInputField;
